import React from 'react';
import {Row, Col, Container} from 'react-bootstrap';
import './Accesscontrol.css';

const Accesscontrol = function(props) {
    return (
        <Container fluid>
            <Row style={{margin:'auto'}}>
                <p> Access Control </p>
            </Row>
        </Container>
    )
}

export default Accesscontrol;